import React, { useRef } from 'react';

import { useBreakpoint } from 'Components/misc/Breakpoints/Breakpoints';
import StickyVRM from 'Components/misc/StickyVRM/StickyVRM';
import DialogLoader from 'Components/transitions/DialogLoader/DialogLoader';
import { Content } from 'LegacySBCRA/Content/Content';

import { ContentRouter } from './components/ContentRouter/ContentRouter';
import { Header } from './components/Header/Header';
import { Sidebar } from './components/Sidebar/Sidebar';
import { useBreadcrumbNavigation } from './hooks/useBreadcrumbNavigation';
import { useContentType } from './hooks/useContentType';
import { useTimers } from './hooks/useTimers';
import { useWPData } from './hooks/useWPData';

import styles from './WordpressPages.scss';

const WordpressPages: React.FC = () => {
  const contentRef = useRef<HTMLDivElement>(null);

  const { data, empty, isBlog, isPage, isSSR, ready } = useWPData();
  const { fetchBlogTitleAndTopNav } = useBreadcrumbNavigation();
  const { contentType } = useContentType({ data, empty, isBlog, isPage });
  const { stickyVRM } = useTimers();
  const breakpoints = useBreakpoint();

  const tabletBreakpoint = breakpoints.maxWidth.breakpointTablet;

  if (!ready) {
    return <DialogLoader />;
  }

  const { blogTitle: pageTitle, topNav } = fetchBlogTitleAndTopNav();

  return (
    <Content ref={contentRef} className={styles.view}>
      <section>
        {tabletBreakpoint && stickyVRM && contentRef.current && (
          <StickyVRM $content={contentRef.current} />
        )}
        <div className={styles.content} id="content">
          <Header {...{ pageTitle, topNav }} />
          <ContentRouter {...{ contentType, data, isSSR }} />
        </div>
        <Sidebar {...{ contentType, data }} />
      </section>
    </Content>
  );
};

export default WordpressPages;
